export default function() {
	try {
		localStorage.setItem('__nearpod__', '1')
		localStorage.removeItem('__nearpod__')
		return true
	} catch (error) {
		return false
	}
}
